import React, { Component } from 'react';
import classNames from 'classnames'
import styles from './index.css';
import Title from '../../blocks/Title'
import MyIcons from '../../blocks/MyIcons'
import MyLink from '../../blocks/MyLink'
import {LangChangeEventContext} from '../../contexts/LangContext';

import AOS from 'aos/dist/aos.js'; 
import 'aos/dist/aos.css';

var timeIntervalId, arrImgWr, curItem = 0;

export default class Main extends Component {  
  componentWillMount(){
   
  }
  componentDidMount(){
    AOS.init({once:true, startEvent: 'DOMContentLoaded'});
    this.galleryStart();
  }
  componentWillUnmount(){
    clearInterval(timeIntervalId);
  }
  galleryStart = () =>{
    arrImgWr = this.galWrap.childNodes;
    arrImgWr[0].classList.add(styles['is-active'])
    curItem ++;
    timeIntervalId = setInterval(()=>{
      if(arrImgWr[curItem]){
        if(curItem<(arrImgWr.length-1)){
          arrImgWr[curItem].classList.remove(styles['is-active']);
          curItem ++;
          arrImgWr[curItem].classList.add(styles['is-active']);
        }else{
          arrImgWr[curItem].classList.remove(styles['is-active']);
          curItem = 0;
          arrImgWr[curItem].classList.add(styles['is-active']);
        }
      }
    },4000)
  }
  
  render() {
    return (
      <LangChangeEventContext.Consumer>
        {({lang}) =>(
            <div className={classNames(styles['aboutBody'])} >
             
              <div className={classNames(styles['backgroundImgWrapper'])}
                    data-aos="fade-up" data-aos-offset="50"
                  >  
                <img alt="" src={this.props.ADMIN_URL+this.props.bg} className={styles['backgroundImg']} /> 
                <div className={classNames(styles['backgroundGradient'])} > </div>
              </div>

              <div className={classNames(styles['contentWrapper'])}>
                <div className={classNames(styles['header'])}>

                  <div className={classNames(styles['titleStyleWrapper'])}  
                      data-aos="fade-up" data-aos-offset="50"  data-aos-delay="200"
                      >
                    <Title 
                      classStyle  = {styles['titleStyle']} 
                      colorStyle  = "black1"  
                      title       = "DANTE KITCHEN + BAR" 
                      text        = {lang.t('aboutSubHeader')}
                      logo        = {true}
                    />
                  </div>

                  <div className={classNames(styles['blockText'],styles['phoneMobile'])}   
                      data-aos="fade-up" data-aos-offset="50"  data-aos-delay="400"
                       >
                    {lang.t('contactsPhone')}<br/>
                    <a className={styles['phoneLink']} href={'tel:'+lang.t('contactsPhoneLink')}>
                      <div className={styles['phoneText']}>{lang.t('contactsPhoneV')}</div>
                    </a>
                  </div>

                  <div className={classNames(styles['blockText'],styles['phoneMobile'])}   
                      data-aos="fade-up" data-aos-offset="50"  data-aos-delay="600"
                       >
                    {lang.t('contactsAddress')}<br/>
                    <a className={styles['phoneLink']} href="https://yandex.ru/maps/-/CBB8VSTcpB" target="_blank" rel="noopener noreferrer">
                      <div className={styles['phoneText']}>{lang.t('contactsAddressV')}</div>
                    </a>
                  </div>
                  <div className={classNames(styles['blockText'],styles['phoneMobile'],styles['underline'])}   
                      data-aos="fade-up" data-aos-offset="50"  data-aos-delay="800"
                       >
                    <MyLink className={styles['phoneLink']} to="/contacts">
                      <div className={styles['phoneText']}>{lang.t('viewContacts')}</div>
                    </MyLink>
                  </div>

                </div>
                <div className={classNames(styles['content'])}>  

                  <div className={styles['wrapperText']}   
                      data-aos="fade-up" data-aos-offset="150"
                      >  
                    <h3 className={styles['wrapperTextTitle']}>{lang.t('aboutTitle')}</h3>
                    <div className={styles['text']} >
                      {lang.t('aboutText')}
                    </div>
                    <div className={styles['spoon']} >  
                      <MyIcons icon="spoon" width="100px" height="100px"/>
                    </div>
                  </div>  
                   
                  <div className={styles['galleryWrapper']} ref={item => {this.galWrap = item}}   
                      data-aos="fade-up" data-aos-offset="-50" data-aos-delay="1000"
                      > 
                    {JSON.parse(this.props.gallery).map( (img,i) => {
                      return(
                        <div className={styles['galleryImgWrapper']} key={i}>  
                          <img alt="" src={this.props.ADMIN_URL+img.image} className={styles['galleryImg']} />                     
                        </div>  
                      )
                    })}
                  </div>  
                  
                  <div className={styles['bottomBackgroungImgWrapper']} >  
                    <img alt="" src="/assets/img/test.png" className={styles['bottomBackgroungImg']} />                  
                  </div> 

                </div>            
              </div>
            </div>
        )}
      </LangChangeEventContext.Consumer>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/MainAboutMobile/index.js